import type { Sample } from './sample.interface';
import type { SampleCharacteristic } from './sample-characteristic.interface';
import type { Order } from './order.interface';

export interface cv_SampleType {
    Abbreviation: string;
    C_SampleType_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    Sample: Sample[];
    SampleCharacteristic: SampleCharacteristic[];
    Order: Order[];
    SampleType: string;
    SortOrder: number | null;
    Version: number;
}
